var XPortal = XPortal || {};
XPortal.Notificator = (function () {
    var self = {
        BusyClass: "processing",
        Timeout: null,
        Interval: 60000,
        NotificationRequestMaxItemsCount: 300,
        NotificationElement: function () {
            return $(".notifications-dd");
        },
        ProcessUTCDates: function (containerSelector) {
            var container = containerSelector ? $(containerSelector) : $('body');
            var elemToProcess = container.find('[data-utcdate-time]');
            elemToProcess.each(function (index, elem) {
                var tmpDTFormat = $(elem).data('format');
                var tmpElemUTC_DT = $(elem).data('utcdate-time');

                let dateVal = tmpElemUTC_DT instanceof Date ? tmpElemUTC_DT : new Date(tmpElemUTC_DT);
                const nowOffset = new Date().getTimezoneOffset();
                const dateOffset = dateVal.getTimezoneOffset();
                const updData = new Date(dateVal.getTime() - (dateOffset - nowOffset) * 60000);

                var localDate = XPortal.Utils.TransformDateTime(tmpElemUTC_DT, tmpDTFormat, true, false, false, true);
                $(elem).replaceWith(localDate);
            });
        },
        Init: function () {
            requestMemberNotifications(1000);
            self.InitNotificationSetup();
            self.InitNotificationDropdown();
        },
        InitNotificationDropdown: function () {
            // prevent closing of dropdown when clicking inside the dropdown
            $('.dropdown-menu.notifications-container').on("click.bs.dropdown", function (e) {
                e.stopPropagation();
                $('.notifications-dd').addClass('show');
                $('.notifications-container').addClass('show');
            });
        },
        GetSubscriptionsFor: function (gridInfo, options, checkCache) {
            if (!XPortal.Account.Name) return;
            let currentNotifications = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == gridInfo.nodeId);
            if (currentNotifications && checkCache) {
                let diff = moment.duration(Date.now() - currentNotifications.updateDate);
                if (currentNotifications.isExpired || diff._milliseconds > XPortal.Notificator.Interval) {
                    currentNotifications.updateDate = new Date();
                    currentNotifications.assignedNotifications = [];
                    currentNotifications.requestedNotifications = [];
                    currentNotifications.isExpired = false;
                }
            }
            if (!currentNotifications) {
                currentNotifications = { viewId: gridInfo.nodeId, assignedNotifications: [], requestedNotifications: [], updateDate: new Date(), isExpired: false };
                XPortal.Grid.AssignedNotificationsItems.push(currentNotifications);
            }
            //filters already loaded items 
            if (checkCache) {
                options.Items = options.Items.filter(itm => !currentNotifications.requestedNotifications.includes(itm.UniqueId));
                currentNotifications.requestedNotifications = currentNotifications.requestedNotifications.concat(options.Items.map(i => i.UniqueId));
            }
            let itemsToLoad = options.Items.splice(0, (options.Items.length < self.NotificationRequestMaxItemsCount) ? options.Items.length : self.NotificationRequestMaxItemsCount);
            if (itemsToLoad.length > 0) {
                var partialOptions = { EntityAlias: options.EntityAlias, Items: itemsToLoad };
                self.GetAssignedNotificationsListPartial(gridInfo, partialOptions).then(function onDone() {
                    if (options.Items.length > 0) {
                        partialOptions.Items = options.Items;
                        self.GetSubscriptionsFor(gridInfo, partialOptions);
                    } else
                        self.MarkAssignedNotifications(gridInfo);
                });
            } else self.MarkAssignedNotifications(gridInfo);
        },
        MarkAssignedNotifications: function (gridInfo) {
            if (!XPortal.Account.Name || !gridInfo.kgrid) return;
            const store = gridInfo.data || gridInfo;
            clearTimeout(store.kgridRefreshInterval);
            store.kgridRefreshInterval = setTimeout(function () {
                gridInfo.kgrid.refresh();
                // re-render the tile (list view) so the per-tile notification icon (IsDNotifOn) updates too
                if (gridInfo.klist) gridInfo.klist.refresh();
            }, 50);
        },
        GetAssignedNotificationsListPartial: function (gridInfo, options) {
            if (options.Items.length < 1) return;
            options.AllKeysItems = options.Items.map(i => i.AllKeysValue);
            options.Items = options.Items.map(i => i.UniqueId);

            return XPortal.Notificator.AjaxCall({ element: gridInfo.grid, data: kendo.stringify(options), url: gridInfo.grid.attr("data-sbnotifications-url") }, function (element, data) {
                if (data.State !== 0) return;
                var currentNotifications = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == gridInfo.nodeId);
                currentNotifications.assignedNotifications = currentNotifications.assignedNotifications.concat(data.Items);
            });
        },
        InitNotificationSetup: function () {
            //setup menu items - only edit form now      
            if ($(".notifications-dd[manage-url]").length > 0) {
                $("#manageNotifications").on("click", function () {
                    window.location.href = XPortal.Notificator.NotificationElement().attr("manage-url");
                });
            }

            $("#mark-all-readed-link").on("click", function (e) {
                e.preventDefault();
                XPortal.Notificator.AjaxCall({
                    element: XPortal.Notificator.NotificationElement(),
                    data: kendo.stringify({ EntityAlias: "GeneratedNotifications" }),
                    url: XPortal.Notificator.NotificationElement().attr("readall-url")
                }, function () {
                    requestMemberNotifications(1);
                });
            });
        },
        ModifyNotificationSubscription: function (options, successCallback, completeCallback) {
            var editFormParameters = options;// XPortal.EditForm.EditFormParameters();
            if (!editFormParameters)
                return;
            var params = {
                relatedUidList: [editFormParameters.UniqueId],
                relatedAlias: editFormParameters.Alias,
                relatedDetailId: editFormParameters.NodeId,
                relatedUrl: editFormParameters.RelatedUrl,
                nodeId: editFormParameters.NodeId,
                notificationTitle: options.notificationTitle,
                notificationDescription: options.notificationDescription,
                entityAlias: "PortalNotifications"
            }
            XPortal.Notificator.AjaxCall({
                element: XPortal.Notificator.NotificationElement(),
                data: kendo.stringify(params),
                url: options.url
            }, function onSuccess(element, data) {
                if (data.State === 0 && successCallback) {
                    successCallback(element, data);
                }
            }, function onComplete() {
                if (completeCallback) completeCallback();
            });
        },
        ToggleSubscriptionAdd: function (options) {
            const $notifyWatch = $(options.button);
            options.isPresent ? $notifyWatch.addClass("notificationsPresent") : $notifyWatch.removeClass("notificationsPresent");
            let addRemoveText = options.isPresent ? options.command.addtitle : options.command.remtitle;
            $(options.button).attr("title", addRemoveText);
            $(options.button.find("i")).replaceWith(options.isPresent ? options.command.addicon : options.command.remicon)
            $(options.button).children(".dm-item-text").text(addRemoveText);
            $(options.menuButton).children(".dm-item-text").text(addRemoveText);
        },
        GetNotificationSubscription: function (options, sucessCallback) {
            var editFormParameters = XPortal.Store.GetModelByName(options.modelName).model;// XPortal.EditForm.EditFormParameters();
            if (!editFormParameters || editFormParameters.IsWizardPage)
                return;
            if (editFormParameters.IsCreating) {
                sucessCallback(options.button, []);
                return;
            }
            var params = {
                UniqueId: editFormParameters.UniqueId,
                MemberUser: XPortal.Account.Name,
                EntityAlias: "PortalNotifications"
            }

            XPortal.Notificator.AjaxCall({
                data: kendo.stringify(params),
                url: XPortal.Notificator.NotificationElement().attr("getsubscriptions-url")
            }, sucessCallback);
        },
        AddRemoveNotificationsSubscription: function (options) {
            if (options.button.hasClass(XPortal.Notificator.BusyClass))
                return;
            options.button.addClass(XPortal.Notificator.BusyClass);
            var isPresent = options.button.hasClass("notificationsPresent") ? true : false;
            var url = !isPresent ? XPortal.Notificator.NotificationElement().attr("addnotification-url")
                : XPortal.Notificator.NotificationElement().attr("removesubscriptions-url");

            XPortal.Loader.show({ 'selector': options.menuButton, size: '1.5rem' });
            XPortal.Loader.show({ 'selector': options.button });
            var data = Object.assign({}, XPortal.Store.GetModelByName(options.modelName).model, {
                url: url, isNotificationsPresent: isPresent,
                notificationDescription: options.button.attr("notif-description"),
                notificationTitle: options.button.attr("notif-title")
            });
            XPortal.Notificator.ModifyNotificationSubscription(data, function success() {
                options.isPresent = !isPresent;
                XPortal.Notificator.ToggleSubscriptionAdd(options);
            }, function done() {
                options.button.removeClass(XPortal.Notificator.BusyClass);
                XPortal.Loader.hide({ 'selector': options.menuButton });
                XPortal.Loader.hide({ 'selector': options.button });
            });
        },
        ReadNotifications: function (options, doneHandler) {
            XPortal.Notificator.AjaxCall(options, undefined, doneHandler);
        },
        DisplayNotifications: function (element, xdata) {
            var list = $(".notifications-container", element);
            requestMemberNotifications();
            if (xdata && xdata.State > -1 && list.length > 0 &&
                xdata.Result && xdata.Result.Items && xdata.Result.Items.length > 0) {
                var data = {
                    notifications: xdata.Result.Items.map(function (itm) {
                        return {
                            UniqueId: itm.UniqueId,
                            Fields: JSON.parse(itm.Json)
                        }
                    }).map(function (itm) {
                        itm.Title = getFieldVal(itm, "Title");
                        itm.Description = getFieldVal(itm, "Description");
                        itm.Icon = getFieldVal(itm, "Icon");
                        itm.Date = getFieldVal(itm, "Created");
                        const notifiedUsersStringValue = getFieldVal(itm, "NotifiedMemberUserName");
                        itm.NotifiedUsers = notifiedUsersStringValue ? JSON.parse(notifiedUsersStringValue) : [];
                        return itm;
                    }).map(function (itm) {
                        itm.Read = itm.NotifiedUsers.find(usr => usr.value === XPortal.Account.Name) ? true : false;
                        itm.Readed = itm.Read ? "readed" : "";
                        var dateObj = new Date(itm.Date);
                        itm.FromNow = moment(dateObj).fromNow();
                        itm.Icon = itm.Icon.startsWith("fa ") ? itm.Icon : "fa " + itm.Icon;
                        return itm;
                    }).sort(function (a, b) {
                        if (a.Read && b.Read) {
                            if (moment(a.Date) < moment(b.Date))
                                return 1;
                            else return -1;
                        }
                        if (a.Read && !b.Read) {
                            return 1;
                        }
                        if (!a.Read && b.Read) {
                            return -1;
                        }
                        if (!a.Read && !b.Read) {
                            if (moment(a.Date) < moment(b.Date))
                                return 1;
                            else return -1;
                        }
                        return 0;
                    }),
                    displayNotificationItem: function (e) {
                        if ($(e.target).is('.xpand-list > *:first-child') || $(e.target).is('a, a *')) return;
                        e.preventDefault();
                        var readCheckClassStatus = "notif-status"; //omit checkbox with class notif-status
                        var read = true;
                        if ($(e.target).closest(".dropdown-item").find("." + readCheckClassStatus).hasClass("readed")) {
                            read = !e.currentTarget.kendoBindingTarget.source.Read;
                        }
                        var uid = e.currentTarget.kendoBindingTarget.source.Fields.find(f => f.Name === "RelatedEntityUniqueId").StringValue;
                        var pageId = e.currentTarget.kendoBindingTarget.source.Fields.find(f => f.Name === "RelatedPageId").StringValue;
                        var pagePageUrl = e.currentTarget.kendoBindingTarget.source.Fields.find(f => f.Name === "RelatedPageUrl").StringValue;
                        XPortal.Notificator.ReadNotifications({
                            element: element,
                            data: kendo.stringify({
                                EntityAlias: "GeneratedNotifications",
                                ReadIdList: [{
                                    UniqueId: e.currentTarget.kendoBindingTarget.source.UniqueId,
                                    Read: !read
                                }]
                            }),
                            url: element.attr("read-url")
                        }, function (el, data) {
                            if (data.status === 200) {
                                $(e.currentTarget).find("." + readCheckClassStatus).toggleClass("readed");
                                //update counter
                                var $notifCounter = $(".notifyCounter");
                                var notReadItemsCount = $("span.notif-status:not(.readed)").length;

                                if (notReadItemsCount > 9) notReadItemsCount = '9+';
                                $notifCounter.text(notReadItemsCount);

                                if (notReadItemsCount) {
                                    $notifCounter.parent().addClass('not-readed');
                                } else {
                                    $notifCounter.parent().removeClass('not-readed');
                                }
                            }
                        });

                        if (uid && pageId && pagePageUrl && (!$(e.target).hasClass('notif-footer') && !$(e.target).hasClass('notif-status') && !$(e.target).hasClass('notif-time-info'))) {
                            XPortal.GridActions.ShowPage({
                                uid: uid,
                                url: pagePageUrl,
                                action: XPortal.EditForm.SetEditLocationUrl
                            });
                        }
                    }
                };

                XPortal.Notificator.UpdateCounter(data);

                var dataModel = new kendo.observable(data);
                kendo.unbind(list);
                kendo.bind(list, dataModel);
                $("#notificationsItemsPresent").removeClass("d-none");
                $(".notifications-items").removeClass("d-none");
                $("#notificationsItemsNotPresent").addClass("d-none");
            } else {
                $("#notificationsItemsNotPresent").removeClass("d-none");
                $("#notificationsItemsPresent").addClass("d-none");
                $(".notifications-items").addClass("d-none");
            }
            XPortal.Notificator.ProcessUTCDates();
        },
        UpdateCounter: function (data) {
            var $notifCounter = $(".notifyCounter");
            var notReadItemsCount = data.notifications.filter(itm => !itm.Read).length;
            if (notReadItemsCount > 9) notReadItemsCount = '9+';
            $notifCounter.text(notReadItemsCount);

            if (notReadItemsCount) {
                $notifCounter.parent().addClass('not-readed');
            } else {
                $notifCounter.parent().removeClass('not-readed');
            }
        },
        GetNotifications: function (element) {
            element = element ? element : XPortal.Notificator.NotificationElement();
            var options = {
                EntityAlias: "GeneratedNotifications",
                PageIndex: 1,
                PageSize: 20,
                Sort: [{ name: "srt_created", dir: "desc" }],
                Filter: { logic: "and", filters: [{ field: "memberusername", operator: "contains", value: XPortal.Account.Name }] },
                Keywords: ""
            };
            var rdata = kendo.stringify({ model: options });
            XPortal.Notificator.AjaxCall({ element: element, data: rdata, url: element.attr("data-url") }, XPortal.Notificator.DisplayNotifications);
        },
        AjaxCall: function (options, sucessCallback, completeCallback) {
            options = options || {};
            if (options.url && options.data) {
                return jQuery.ajax({
                    method: "POST", dataType: "json", cache: false, contentType: 'application/json; charset=utf-8', url: XPortal.Utils.EnsureInProfile(options.url), data: options.data,
                    headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                    success: function (xdata) {
                        if (sucessCallback)
                            sucessCallback(options.element, xdata);
                    },
                    complete: function (xdata) {
                        if (completeCallback)
                            completeCallback(options, xdata);
                        requestMemberNotifications();
                    }
                });
            } else
                if (console) console.warn('there is no chance to get portal notifications.', options, 'Empty options:url or data');
        }
    };
    function getFieldVal(item, fname) {
        if (!fname || !item || !item.Fields) return "";
        fname = fname.toLowerCase();
        const f = item.Fields.find(f => (f.Name || "").toLowerCase() == fname);
        if (!f) return "";
        return f.StringValue || "";
    };
    function requestMemberNotifications(itimeout) {
        clearTimeout(self.Timeout);
        self.TimeoutInterval = self.TimeoutInterval ? self.TimeoutInterval : itimeout;
        self.Timeout = setTimeout(function () {
            self.TimeoutInterval = false;
            self.GetNotifications();
        }, self.TimeoutInterval || self.Interval);
    }
    return self;
}());